import BaseSystemApi from 'api/BaseSystemApi';
import { env } from 'env';

export default class LoanOriginationSystemApi<Resource = unknown> extends BaseSystemApi<Resource> {
  protected origin = env.REACT_APP_LOS_API_URL;
}
